/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import user from 'js/lib/user';

import { PageNotification } from '@coursera/cds-core';

import { AUTOJOIN_BANNER_DISMISSED } from 'bundles/enterprise-legacy-learner-home/components/modals/constants';
import storageUtils from 'bundles/enterprise-legacy-learner-home/utils/storageUtils';
import { useProgram, useProgramMembership } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

import _t from 'i18n!nls/program-home';

const ProgramJoinNotification: React.FC = () => {
  const program = useProgram();
  const { membershipCreatedAt, isProgramMember } = useProgramMembership();
  const userId = user.get().id;
  const programId = program?.id || '';
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (programId && membershipCreatedAt) {
      const currentTime = Date.now(); // Current time in ms
      const oneMinuteAgo = currentTime - 60 * 1000; // Timestamp for one minute ago
      const hasJoinedRecently = membershipCreatedAt >= oneMinuteAgo;
      const hasDismissed = storageUtils.get(userId, programId, AUTOJOIN_BANNER_DISMISSED, false);
      const showNotification = hasJoinedRecently && !!isProgramMember && !hasDismissed;
      setIsVisible(showNotification);
    }
  }, [programId, userId, membershipCreatedAt, isProgramMember]);

  const onDismiss = () => {
    setIsVisible(false);
    storageUtils.set(userId, programId, AUTOJOIN_BANNER_DISMISSED, true);
  };

  if (!isVisible || !programId) {
    return null;
  }

  return (
    <PageNotification severity="success" onDismiss={onDismiss} className="program-sso-notification">
      {_t(`You've joined the “#{programName}” learning program.`, { programName: program?.metadata.name })}
    </PageNotification>
  );
};

export default ProgramJoinNotification;
